import React from 'react';

const Loading = () => {
    return (
        <div className='flexible  h-[700px]'>
            <progress className="mx-20 progress w-2/4"></progress>
        </div>
    );
};

export default Loading;